import React from 'react';
import MaintenanceModeWrapper from '../containers/MaintenanceModeWrapper';
import { useSelector } from 'react-redux';

const IsNotMaintenanceMode = ({ children }) => {
    const account = useSelector((state) => state.account);

    if (account.isMaintenanceMode) {
        return <MaintenanceModeWrapper />;
    } else {
        return <div>{children}</div>;
    }
};

export default IsNotMaintenanceMode;
